import { CardBody, CardHeader, CardFooter, Card, Row, Col, Label } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import ColorSelectorModal from '../common/controls/colorSelectorModal';
import SaveButton from '../common/controls/saveButton';
import Loader from '../common/loader';
import InfoEditor from './infoEditor';
import FreeTextEditor from './freeTextEditor';
const capitalizeFirstLetter = string => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const AnnotationDetailViewPanel = _ref => {
  let _ref$saveState = _ref.saveState,
    saveState = _ref$saveState === void 0 ? 'disabled' : _ref$saveState,
    _ref$annotation = _ref.annotation,
    annotation = _ref$annotation === void 0 ? {} : _ref$annotation,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    containerMaxHeight = _ref.containerMaxHeight,
    handleSave = _ref.handleSave,
    onChange = _ref.onChange;
  const selectionMessage = type ? /*#__PURE__*/React.createElement("h3", {
    className: "t-aedvp-edit-header"
  }, "Select ", type.charAt(0) === 'i' ? 'an' : 'a', " ", type, " annotation") : /*#__PURE__*/React.createElement("h3", {
    className: "t-aedvp-header"
  }, "Select an annotation type to edit");

  // static now, but can re-size if additional items are added to the card header
  const headerHeight = 59;
  const footerHeight = 59;
  const handleColorChange = color => onChange('colorString', color);
  let editorContents = null;
  if (type === 'info') {
    editorContents = /*#__PURE__*/React.createElement(InfoEditor, {
      annotation: annotation,
      onChange: onChange
    });
  } else if (type === 'freeText') {
    editorContents = /*#__PURE__*/React.createElement(FreeTextEditor, {
      annotation: annotation,
      onChange: onChange
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      minWidth: 250
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    id: "detail-card-header",
    style: {
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(SaveButton, {
    onSave: handleSave,
    saveState: saveState,
    className: "t-aedvp-save",
    size: "sm"
  }))), /*#__PURE__*/React.createElement(CardBody, {
    style: {
      maxHeight: containerMaxHeight - headerHeight - footerHeight,
      overflow: 'auto'
    },
    className: "t-aedvp-".concat(type, "-container")
  }, /*#__PURE__*/React.createElement(Loader, {
    loaded: !loading
  }, Object.keys(annotation).length ? /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h3", null, capitalizeFirstLetter(type), " Annotation"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    style: {
      paddingBottom: '10px'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Label, null, "Color")), /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(ColorSelectorModal, {
    className: "t-aedvp-color-selector",
    selectedColor: annotation.colorString,
    onChange: handleColorChange,
    indicatorShape: "rectangle"
  }))), editorContents) : selectionMessage)), footer ? /*#__PURE__*/React.createElement(CardFooter, {
    style: {
      paddingLeft: 10,
      paddingRight: 10
    }
  }, footer) : null);
};
AnnotationDetailViewPanel.propTypes = {
  type: PropTypes.string,
  loading: PropTypes.bool,
  annotation: PropTypes.shape({
    id: PropTypes.string,
    colorString: PropTypes.string
  }),
  containerMaxHeight: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  footer: PropTypes.node,
  saveState: PropTypes.string
};
export default AnnotationDetailViewPanel;